import { render, staticRenderFns } from "./tablets.vue?vue&type=template&id=314ccb6e&scoped=true"
import script from "./tablets.vue?vue&type=script&lang=ts"
export * from "./tablets.vue?vue&type=script&lang=ts"
import style0 from "./tablets.vue?vue&type=style&index=0&id=314ccb6e&prod&lang=css"
import style1 from "./tablets.vue?vue&type=style&index=1&id=314ccb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314ccb6e",
  null
  
)

export default component.exports